import { type FC } from 'react';
import { GiAlliedStar } from 'react-icons/gi';

import styles from './SNHUCardBadge.module.css';

type Props = {
  text?: string;
};
const SNHUCardBadge: FC<Props> = ({ text }) => (
  <div className={styles.badge}>
    {' '}
    <GiAlliedStar />
    {text}
  </div>
);

export default SNHUCardBadge;
